import React from "react";
import { useQuery } from "react-query";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { Container } from "../../lib";
import { getFanReportLogAllMatch } from "../../../../api/report/reportApi";
import BackBtn from "../../lib/BackBtn";
import FansReportLogTable from "./FansReportLogTable";

interface LocationState {
  nationalCode: string;
}

const FansReportLogList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const nationalCode = (location.state as LocationState)?.nationalCode;

  React.useEffect(() => {
    if (!nationalCode) {
      navigate(-1);
    }
  }, [nationalCode, navigate]);

  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1");
  const search = searchParams.get("search") || "";
  const numberInPage = parseInt(searchParams.get("numberInPage") || "10");

  const { data, isLoading, isError, refetch } = useQuery(
    ["fansReportLog", page, search, numberInPage, nationalCode],
    () =>
      getFanReportLogAllMatch(nationalCode, {
        page,
        search,
        numberInPage,
      }),
    {
      enabled: !!nationalCode,
    }
  );

  const handlePageChange = (newPage: number) => {
    setSearchParams({
      page: newPage.toString(),
      ...(search && { search }),
      numberInPage: numberInPage.toString(),
    });
  };

  if (isLoading) return <div>در حال بارگذاری...</div>;
  if (isError) return <div>خطا در دریافت اطلاعات</div>;

  return (
    <Container className="bg-white p-0 mt-10">
      <div className="d-flex align-items-center justify-content-between table-header">
        <div className="d-flex align-items-center gap-4">
          <h3>گزارش فعالیت‌های هوادار</h3>
        </div>
        <BackBtn onClick={() => navigate(-1)} />
      </div>

      {data?.userLogs && data.userLogs.length > 0 ? (
        <FansReportLogTable
          data={data}
          queryString={{
            page,
            search,
            numberInPage,
          }}
          nationalCode={nationalCode}
          setQueryString={handlePageChange}
          refetch={refetch}
        />
      ) : (
        <p className="p-2 m-2">اطلاعاتی یافت نشد</p>
      )}
    </Container>
  );
};

export default FansReportLogList;
